import { lazy, Suspense } from "react";
import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import Index from "./pages/Index";
import GARouteTracker from "./components/GARouteTracker";

const Pricing = lazy(() => import("./pages/Pricing"));
const DigitalSignatures = lazy(() => import("./pages/DigitalSignatures"));
const About = lazy(() => import("./pages/About"));
const Contact = lazy(() => import("./pages/Contact"));
const LegalPage = lazy(() => import("./pages/LegalPage"));
const Sitemap = lazy(() => import("./pages/Sitemap"));
const TenantPortal = lazy(() => import("./pages/TenantPortal"));
const Blog = lazy(() => import("./pages/Blog"));
const BlogPost = lazy(() => import("./pages/BlogPost"));
const NotFound = lazy(() => import("./pages/NotFound"));
const LandingPage = lazy(() => import("./pages/LandingPage"));
const LPThankYou = lazy(() => import("./pages/LPThankYou"));
const CityPage = lazy(() => import("./pages/CityPage"));
const SoftwareLanding = lazy(() => import("./pages/SoftwareLanding"));

const queryClient = new QueryClient();

const App = () => (
  <HelmetProvider>
    <QueryClientProvider client={queryClient}>
      <TooltipProvider>
        <Toaster />
        <Sonner />
        <BrowserRouter>
          <GARouteTracker />
          <Suspense fallback={null}>
            <Routes>
              <Route path="/" element={<Index />} />
              <Route path="/pricing" element={<Pricing />} />
              <Route path="/digital-signatures" element={<DigitalSignatures />} />
              <Route path="/about" element={<About />} />
              <Route path="/tenant-portal" element={<TenantPortal />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/blog" element={<Blog />} />
              <Route path="/blog/:slug" element={<BlogPost />} />
              <Route path="/cities/:slug" element={<CityPage />} />
              <Route path="/software/:slug" element={<SoftwareLanding />} />
              <Route path="/terms" element={<LegalPage />} />
              <Route path="/privacy" element={<LegalPage />} />
              <Route path="/accessibility" element={<LegalPage />} />
              <Route path="/sitemap" element={<Sitemap />} />
              <Route path="/lp/facebook" element={<LandingPage source="facebook" />} />
              <Route path="/lp/google" element={<LandingPage source="google" />} />
              <Route path="/lp/thank-you" element={<LPThankYou />} />
              <Route path="/404" element={<NotFound />} />
              <Route path="*" element={<NotFound />} />
            </Routes>
          </Suspense>
        </BrowserRouter>
      </TooltipProvider>
    </QueryClientProvider>
  </HelmetProvider>
);

export default App;
